import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, NavController } from '@ionic/angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app/app.component';
import { AppRoutingModule } from './app/app-routing.module';
import { environment } from './environments/environment';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { AuthModule } from '@libs/core/auth';
import { AuthFmaModule, AuthService } from '@libs/core/auth-fma';
import { PrivacyPolicyModule } from '@libs/core/privacy-policy';
import { hasAcceptedPrivacyPolicy } from '@libs/core/privacy-policy';
import { ProfileService, ApiModule, AttachmentsService } from '@libs/core/api';
import { StorageModule } from '@libs/core/storage';
import { LayoutModule } from '@libs/ui/layout';
import { IonicHooksModule } from '@libs/core/ionic-hooks';
import { SharedModule, PlatformDetectionService } from '@libs/util/shared';
import { ColorModule } from '@libs/core/color';
import { StatusBarModule } from '@libs/ui/status-bar';
import { NavigationBarModule } from '@libs/ui/navigation-bar';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { BlobStorageModule } from '@libs/core/blob-storage';
import { EnvironmentBannerModule } from '@libs/ui/environment-banner';
import { MonitoringModule } from '@libs/core/monitoring';

import { httpInterceptorProviders } from './app/interceptors/all';
import { AppRouteStrategy } from './app/routing/app-route-reuse-strategy';
import { APP_INITIALIZER } from '@angular/core';
import { initApp } from './app/app.initializer';
// import { devAuthInitializer } from './app/dev-auth.initializer';
// import { StorageService } from '@libs/core/storage';
import { logoutInitializer } from './app/logout.initializer';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserAnimationsModule,
      AppRoutingModule,
      IonicModule.forRoot(),
      StoreModule.forRoot({}),
      EffectsModule.forRoot([]),
      StoreDevtoolsModule.instrument({
        maxAge: 25,
        logOnly: environment.production,
      }),
      StorageModule.forRoot(),
      AuthModule.forRoot({
        authenticateOptions: environment.auth,
      }),
      PrivacyPolicyModule.forRoot({
        privacyPolicyUrl: environment.privacyPolicyUrl,
        acceptPrivacyPolicyService: ProfileService,
      }),
      AuthFmaModule.forRoot(),
      HttpClientModule,
      ApiModule.forRoot({
        rootUrl: environment.apiUrl,
      }),
      LayoutModule,
      IonicHooksModule,
      SharedModule,
      ColorModule.forRoot(),
      StatusBarModule.forRoot(),
      NavigationBarModule.forRoot(),
      NgxSkeletonLoaderModule.forRoot({
        animation: 'pulse',
      }),
      BlobStorageModule.forRoot({
        tokenService: AttachmentsService,
      }),
      MonitoringModule.forRoot({
        appName: 'fleet-management-accident',
        sentryDsn: environment.sentry.dsn,
        appVersion: environment.appVersion,
        appEnvironment: environment.appEnvironment,
        enable: environment.sentry.enable,
        sentryType: 'capacitor',
      }),
      EnvironmentBannerModule,
    ),
    { provide: RouteReuseStrategy, useClass: AppRouteStrategy },
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      multi: true,
      deps: [AuthService, PlatformDetectionService],
    },
    // // Seed test credentials at startup (development only)
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: devAuthInitializer,
    //   multi: true,
    //   deps: [StorageService, AuthService],
    // },
    {
      provide: APP_INITIALIZER,
      useFactory: logoutInitializer,
      multi: true,
      deps: [AuthService, NavController],
    },
    ...httpInterceptorProviders,
  ],
}).catch((err) => console.log(err));
